import { getContentStorageUrl, getMediaBasePathR2 } from 'helpers';
import { ContentType } from 'types';
import type { Article } from 'types';

export const isVideoSatsang = (article?: Article) => article?.articleType === 'satsang' && article.mediaType === 'video';
export const allowsDevicePlayer = (article: Article) => article.allowDevicePlayer !== false;

export function articleVideoSource(article: Article): string {
	if (!article.mediaUriR2 && !article.mediaUri) throw new Error('This video has no media source.');
	return getContentStorageUrl(ContentType.Article, article.articleType, article);
}

export function articleVideoPoster(article: Pick<Article, 'videoPosterUriR2'>): string | undefined {
	if (!article.videoPosterUriR2) return undefined;
	const host = getMediaBasePathR2();
	if (!host) return undefined;
	return new URL('appstatic/media/' + article.videoPosterUriR2.split('/').map(encodeURIComponent).join('/'), host).href;
}

export function videoCardHeight(width: number) {
	return Math.ceil(Math.min(720, Math.max(0, width - 16)) * 9 / 16) + 172;
}
